import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import _moment from './utils/moment'
import _btn from './utils/competence'
import wxUtils from './utils/wxUtils.js'



import 'vant/lib/index.css';
import './assets/icon/iconfont.css'
import './main.less'
import { Switch } from 'vant';
import { Area } from 'vant';
import { TreeSelect } from 'vant';
import { Popup } from 'vant';
import { DatetimePicker } from "vant";

import { Search } from 'vant';
Vue.use(Search);

import { Image as VanImage } from 'vant';

Vue.use(VanImage);

Vue.use(DatetimePicker)

import { Toast } from 'vant';

// Vue.use(Toast);

Vue.prototype.$toast = Toast

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import sha1 from './utils/sha1'
Vue.prototype.sha1 = sha1
Vue.use(Switch);
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(Vant);

Vue.use(_moment)

Vue.use(_btn)

Vue.use(Area)

Vue.use(TreeSelect)

Vue.use(Popup);

Vue.config.productionTip = false;

import 'babel-polyfill'

axios.defaults.baseURL = '/api'

Vue.prototype.$wxUtils = wxUtils

Vue.config.ignoredElements = ['wx-open-launch-weapp']


Vue.use(VueAxios, axios)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
